import { jsx as _jsx } from "react/jsx-runtime";
const LeftIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15.41 16.58L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.58Z", fill: props.color }) })));
};
LeftIcon.defaultProps = {
    color: 'black',
};
export default LeftIcon;
